import React from 'react';
import { motion } from 'framer-motion';
import { trackEvent } from '../utils/metaPixel';
export function FinalCTA() {
  return <section className="py-24 bg-sage relative overflow-hidden" data-id="element-34">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1515377905703-c4788e51af15?q=80&w=1000&auto=format&fit=crop')] opacity-10 bg-cover bg-center mix-blend-overlay" data-id="element-35" />

      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center relative z-10" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-37">
          <h2 className="text-4xl lg:text-5xl font-medium text-white mb-8 leading-tight" data-id="element-38">
            Empieza hoy con una rutina más simple y natural
          </h2>
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="bg-white text-olive px-10 py-4 rounded-full text-lg font-medium shadow-lg hover:bg-cream transition-colors duration-300" onClick={() => {
          trackEvent('InitiateCheckout', {
            content_name: 'Método Piel Clara Natural'
          });
          window.open('https://ideasquetransforman.store/products/piel-radiante-en-casa', '_blank');
        }} data-id="element-39">
            Acceder ahora
          </motion.button>
        </motion.div>
      </div>
    </section>;
}